
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class MenuScheduleRepository extends BaseFirebaseRepository {
    isUseAPI = true

    /**
     * @param {*} app
     * @return {MenuScheduleRepository}
     */
    static getInstance(app, options = {}) {
        if (app == null) {
            // By default, use instance created from main App
            app = MenuScheduleRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new MenuScheduleRepository(app)
            if (options.merchantId) {
                instances[app].merchantId = options.merchantId
            }
        }
        return instances[app]
    }

    static getDefaultInstance() {
        if (window.merchant_id) {
            return MenuScheduleRepository.getInstance(null, {merchantId: parseInt(window.merchant_id)})
        }
        else {
            return MenuScheduleRepository.getInstance()
        }
    }
    getBaseObject = () => {
        return {}
    }

    reloadDataEventThrottleTime = () => {
        return 5000
    }

    getReloadEventKey = () => {
        return "MenuScheduleRepository.changed"
    }

    getApiBaseUrl = (id) => {
        if (this.app == 'UserApp') {
            if (id && id !== 'all') {
                return `/customer/api/merchant/${window.merchant_id}/menu_schedule/${id}`
            }
            return `/customer/api/merchant/${window.merchant_id}/menu_schedule`
        }
        else {
            if (id && id !== 'all') {
                return `/merchant/api/menu_schedule/${id}`
            }
            return '/merchant/api/menu_schedule'
        }
    }
    getBaseObject = () => {
        return {}
    }
    parseRawApiResponse = (res) => {
        let data = res || []
        if (!Array.isArray(res)) {
            data = [res]
        }
        data.forEach(d => {
            if (d.days && Array.isArray(d.days)) {
                d.days.sort((a, b) => a - b)
            }
        })
        return data
    }
    create = (data) => {
        return new Promise((resolve, reject) => {
            const url = this.getApiBaseUrl()
            $.ajax({
                url     : url,
                type    : 'post',
                data    : data,
                success : (res) => {
                    res = this.parseRawApiResponse(res)[0]
                    let item = this.preprocessItem(res)
                    item = Object.assign(this.getBaseObject(), item)
                    item.key = item.id
                    item = this.preprocessItem(item)
                    this.updateMainDataSet(item)
                    resolve(item)
                }
            })
            .always(() => {

            })
            .fail(() => {
                reject()
            })
        })
    }
}
